import { render } from "./GenerateQuizQuestions.vue?vue&type=template&id=dd471dd0&scoped=true&ts=true"
import script from "./GenerateQuizQuestions.vue?vue&type=script&lang=ts"
export * from "./GenerateQuizQuestions.vue?vue&type=script&lang=ts"

import "./GenerateQuizQuestions.vue?vue&type=style&index=0&id=dd471dd0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd471dd0"]])

export default __exports__